export default __webpack_public_path__ + "static/media/bankIcon.c8dd6720.svg";